import React from "react";
import { useParams } from "react-router-dom";
import { useCarContext } from "../context/CarContext";
import { useTranslation } from "react-i18next";
import CarDetailsHeader from "../components/carsdetails/CarDetailsHeader";
import CarDetailsContent from "../components/carsdetails/CarDetailsContent";
import CarDetailsPage from "../components/carsdetails/CarDetailsPage";
import CarImageCarousel from "../components/carsdetails/CarImagecarousel";

import Banner from "../components/Banner";

const CarDetails: React.FC = () => {
  const { carId, lang } = useParams<{
    carId: string;
    lang: "en" | "fr" | "de";
  }>();
  const { cars } = useCarContext();
  const { t } = useTranslation();

  const car = cars.find((car) => car.id === parseInt(carId || "0"));

  if (!car) {
    return <p>{t("carDetails.notFound")}</p>;
  }

  const translation = car.translations[lang || "en"];
  const handleInterest = () => {
    alert(t("carDetails.interestMessage"));
  };

  return (
    <>
      <CarDetailsPage lang={lang || "en"} carId={0} />

      <section className="car-details-page">
        <CarDetailsHeader lang={lang || "en"} title={t("carDetails.back")} />
        <CarImageCarousel images={car.photoGallery} />

        <section className="car-details-section">
          <CarDetailsContent
            car={car}
            translation={translation}
            onInterest={handleInterest}
            lang={""}
          />
        </section>
      </section>
      <Banner />
    </>
  );
};

export default CarDetails;
